import { TopicHeading, HeadingDescSmall } from '../Headings';
import img1 from '../../assets/images/svg/right-arrow-border.svg';
import { AnchorLink } from '../button';
import StatusList from '../status/StatusList';
import './articleWithShortDesc.css';

function ArticleWithShortDesc(props) {
  const { image, topic, desc, btnText, status = [] } = props;

  return (
    <div className="card articleWithShortDesc cardWithHeaderImage">
      <div className="header_img img_box">
        <img src={image} alt="cardImage" />
      </div>
      <div className="card_body">
        <StatusList status={status} />
        <TopicHeading text={topic} />
        <HeadingDescSmall text={desc} />
        <div className="btn_container">
          <img src={img1} alt="right-arrow-border" />
          <AnchorLink text={btnText} />
        </div>
      </div>
    </div>
  );
}

export default ArticleWithShortDesc;
